import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { createSession } from '../lib/api';
import { useAuth } from '../lib/auth';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/admin', { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const user = await createSession(sessionId);
        setUser(user);
        // Clean hash
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/admin/dashboard', { replace: true, state: { user } });
      } catch (e) {
        navigate('/admin?auth_error=1', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white text-zinc-600 font-data text-sm">
      <div className="flex items-center gap-3">
        <span className="inline-block h-2 w-2 bg-zinc-950 animate-pulse" />
        AUTHENTICATING…
      </div>
    </div>
  );
}
